import { Component, Inject, OnInit } from '@angular/core';
import { ClusterElementFragment, ClusterElementsGQL } from "@/core/graphql/graphql";
import {
  ClusterElementsDataSource,
} from "@/modules/clusters/components/cluster-details-modal/components/cluster-elements/cluster-elements.datasource";
import {
  ELEMENTS_COLUMNS,
} from "@/modules/clusters/components/cluster-details-modal/components/cluster-elements/cluster-elements.const";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CosmosDialogService, CosmosDialogStyle } from "@/core/services/cosmos-dialog.service";
import {
  ElementDetailsModalComponent,
} from "@/modules/elements/components/element-details-modal/element-details-modal.component";

@Component({
  selector: 'cosmos-cluster-elements',
  templateUrl: './cluster-elements.component.html',
  styleUrls: ['./cluster-elements.component.scss'],
})
export class ClusterElementsComponent implements OnInit {
  public _columns = ELEMENTS_COLUMNS;
  public _dataSource: ClusterElementsDataSource;

  public constructor(
    private readonly _clusterElementsGql: ClusterElementsGQL,
    private readonly _dialog: CosmosDialogService,
    @Inject(MAT_DIALOG_DATA) private readonly _data: { elementId: number },
  ) {
    this._dataSource = new ClusterElementsDataSource(_clusterElementsGql, this._data.elementId);
  }

  public ngOnInit(): void {
    this._dataSource.loadData();
  }

  public openDetails(row: ClusterElementFragment): void {
    this._dialog.open<ElementDetailsModalComponent, { elementId: number }>(ElementDetailsModalComponent, {
      data: {
        elementId: row.id,
      },
      style: CosmosDialogStyle.Dark,
    });
  }
}

